// Types
import type { ColumnOrderState } from '@tanstack/react-table';

// Utils
import { filterAndMergeArrays } from '@/utils/arrays/filterAndMergeArrays';

export function getVisibleColumns<TColumnsVisibility>(columnsVisibility: TColumnsVisibility) {
    const allKeys = Object.keys(columnsVisibility) as (keyof TColumnsVisibility)[];
    return allKeys.reduce(
        (current, columnId) => {
            if (columnsVisibility[columnId]) {
                current.push(columnId);
            }

            return current;
        },
        [] as (keyof TColumnsVisibility)[]
    );
}

export const getColumnOrderFromCookie = <TColumn extends string>(
    cookieName: string,
    columnsVisibility: Record<TColumn, boolean>
): ColumnOrderState => {
    const dataCookie = localStorage.getItem(cookieName);
    const defaultColumns = getVisibleColumns(columnsVisibility);
    if (!dataCookie) return defaultColumns;
    const dataParsed: ColumnOrderState = JSON.parse(dataCookie);

    return filterAndMergeArrays(dataParsed, defaultColumns);
};
